import { CrmRoleDto } from './crm-role.dto';
import { UserEntity } from 'backend-entity';

export type CrmUserDto = Omit<UserEntity, 'passwordHash' | 'role'> & { role: CrmRoleDto };
